/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BaseComponent from '../../../../panther/components/base/BaseComponent';

import styles from './MicrositeFooter.css';

class MicrositeFooter extends BaseComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let logos = this.renderLogos();
        let copyright = this.renderCopyright();
        let appendix = this.renderAppendix();

        let classes = classNames(
            'container-fluid microsite-footer', {
                'text-centered': this.props.textCentered,
            },
            this.props.className
        );

        return (
            <footer className={classes}>
                {logos}
                {appendix}
                {copyright}
            </footer>
        );
    }

    renderLogos(){
        let links = [];
        this.props.links.map(link => {
            links.push(<a title={link.title} key={link.id} target="_blank" href={link.url}><img alt={link.title} src={require("../../../../resources/img/logo-" + link.id + ".png")}/></a>);
            return links;
        });

        return (
            <Row key="links" className="show-grid footer-logos">
                <Col xs={12} className="centered">
                    {links}
                </Col>
            </Row>
        )
    }

    renderCopyright(){
        let classes = classNames('',{
            'centered': this.props.textCentered
        });

        if (this.props.copyright) {
            let copy = this.props.copyright.text ? `© ${this.props.copyright.text}` : ``;

            if (this.props.copyright.year) {
                copy += ` ${new Date().getFullYear()}`;
            }

            return (
                <Row key={this.props.copyright.text} className="show-grid">
                    <Col className={classes} xs={12}>
                        <p className={classes}>{copy}</p>
                    </Col>
                </Row>
            );
        } else {
            return null;
        }
    }

    renderAppendix() {
        switch (this.props.appendix) {
            case 'climate-fit':
                return this.renderClimateFitAppendix();
            default:
                return null;
        }
    }

    renderClimateFitAppendix() {
        let classes = classNames('',{
            'centered': this.props.textCentered
        });

        return (
            <Row key={this.props.copyright.appendix} className="show-grid">
                <Col className={classes} xs={12}>
                    <div className="footer-appendix climate-fit">
                        <div className="eu-flag">{this.renderEuFlag()}</div>
                        <p>Climate-fit.city is developed as part of the PUCS project, which has received funding from the European Union’s H2020 Research and Innovation Programme under Grant Agreement No. 73004</p>
                    </div>
                </Col>
            </Row>
        );
    }

    renderEuFlag(){
        return (
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width="54" height="36">
                <desc>European flag</desc>
                <defs>
                    <g id="s">
                        <g id="c">
                            <path id="t" d="M0,0v1h0.5z" transform="translate(0,-1)rotate(18)" />
                            <use xlinkHref="#t" transform="scale(-1,1)" />
                        </g>
                        <g id="a">
                            <use xlinkHref="#c" transform="rotate(72)" />
                            <use xlinkHref="#c" transform="rotate(144)" />
                        </g>
                        <use xlinkHref="#a" transform="scale(-1,1)" />
                    </g>
                </defs>
                <rect fill="#039" width="54" height="36" />
                <g fill="#fc0" transform="scale(2)translate(13.5,9)">
                    <use xlinkHref="#s" y="-6" />
                    <use xlinkHref="#s" y="6" />
                    <g id="l">
                        <use xlinkHref="#s" x="-6" />
                        <use xlinkHref="#s" transform="rotate(150)translate(0,6)rotate(66)" />
                        <use xlinkHref="#s" transform="rotate(120)translate(0,6)rotate(24)" />
                        <use xlinkHref="#s" transform="rotate(60)translate(0,6)rotate(12)" />
                        <use xlinkHref="#s" transform="rotate(30)translate(0,6)rotate(42)" />
                    </g>
                    <use xlinkHref="#l" transform="scale(-1,1)" />
                </g>
            </svg>
        );
    }
}

MicrositeFooter.propTypes = {
    appendix: PropTypes.string,
    centered: PropTypes.bool,
    copyright: PropTypes.object,
    links: PropTypes.array
};

export default MicrositeFooter;